import './FormGroup.scss';
import * as React from 'react';
import classNames from 'classnames';
import { Message } from '@/react-ui';
type Props = {
  label?: string;
  className?: string | null;
  errorMessage?: string | null;
  children?: React.ReactNode;
  hint?: string;
};
export default class FormGroup extends React.Component<Props> {
  render() {
    const { className, children, label, errorMessage, hint } = this.props;
    return (
      <div
        className={classNames('FormGroup', className, {
          'FormGroup--invalid': errorMessage != null,
        })}
      >
        {label && <label className="FormGroup-label">{label}</label>}

        {children}

        {hint != null && <div className="FormGroup-hint">{hint}</div>}

        {errorMessage != null && (
          <Message
            variant="negative"
            className="text-sm mt-2 inline-flex px-3 py-2"
          >
            {errorMessage}
          </Message>
        )}
      </div>
    );
  }
}
